import type { QuerySettings } from '@customTypes/index';
import type { SearchParams } from '@customTypes/types';
import { useInfiniteQuery } from '@tanstack/react-query';

import { searchClubs } from '@/features/search/api/search-clubs/request';

export const useSearchClubs = (
  params?: SearchParams,
  settings?: QuerySettings<typeof searchClubs>
) =>
  useInfiniteQuery({
    queryKey: ['searchClubs', params?.countries],
    queryFn: ({ pageParam = 1 }) =>
      searchClubs({
        config: {
          ...settings?.config,
          params: {
            countries: params?.countries,
            pageNumber: pageParam
          }
        }
      }),

    getNextPageParam: (currentPage) =>
      currentPage.data.pageNumber + 1 > currentPage.data.totalPages
        ? null
        : currentPage.data.pageNumber + 1,

    getPreviousPageParam: (currentPage) =>
      currentPage.data.pageNumber - 1 < currentPage.data.totalPages
        ? null
        : currentPage.data.pageNumber - 1,

    initialPageParam: 1
  });

// useQuery({
//   queryKey: ['searchClubs', params?.countries, params?.pageNumber],
//   queryFn: () =>
//     searchClubs({
//       config: {
//         ...settings?.config,
//         params: {
//           countries: params?.countries
//         }
//       }
//     }),
//   ...settings?.options
// });
